<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="isMobile()"
    max-width="700"
    scrollable
  >
    <v-card>
      <toolbar-card-visita
        :opcao_checklist="
          configuracoes.dados.opcoes_checklist.find(
            (oc) => oc.rota == '/producao'
          )
        "
      />
      <v-card-text>
        <v-row
          :dense="isMobile()"
          class="mt-6"
        >
          <v-col md="6" cols="12">
            <v-text-field
              label="Produção média"
              class="font-weight-medium title"
              clearable
              :dense="isMobile()"
              outlined
              inputmode="numeric"
              pattern="[0-9]*"
              v-model="visita.producao_media"
            ></v-text-field>
          </v-col>
          <v-col md="6" cols="12">
            <v-text-field
              label="ECC(Escore de condição corporal)"
              class="font-weight-medium title"
              clearable
              :dense="isMobile()"
              outlined
              inputmode="numeric"
              pattern="[0-9]*"
              v-model="visita.ecc"
            ></v-text-field>
          </v-col>
          <v-col md="6" cols="12">
            <v-text-field
              label="DEL(Dias em lactação)"
              class="font-weight-medium title"
              clearable
              :dense="isMobile()"
              outlined
              inputmode="numeric"
              pattern="[0-9]*"
              v-model="visita.dias_lactacao"
              suffix="dias"
            ></v-text-field>
          </v-col>
          <v-col md="6" cols="12">
            <v-text-field
              label="Gordura do leite"
              class="font-weight-medium title"
              clearable
              :dense="isMobile()"
              outlined
              inputmode="numeric"
              pattern="[0-9]*"
              v-model="visita.gordura_leite"
              suffix="%"
            ></v-text-field>
          </v-col>
          <v-col md="6" cols="12">
            <v-text-field
              label="Proteína do leite"
              class="font-weight-medium title"
              clearable
              :dense="isMobile()"
              outlined
              inputmode="numeric"
              pattern="[0-9]*"
              v-model="visita.proteina_leite"
              suffix="%"
            ></v-text-field>
          </v-col>
          <v-col md="6" cols="12">
            <v-text-field
              label="Lactose"
              class="font-weight-medium title"
              clearable
              :dense="isMobile()"
              outlined
              inputmode="numeric"
              pattern="[0-9]*"
              v-model="visita.lactose"
              suffix="%"
            ></v-text-field>
          </v-col>
          <v-col md="6" cols="12">
            <v-text-field
              label="CSS(Contagem de células somáticas)"
              class="font-weight-medium title"
              clearable
              :dense="isMobile()"
              outlined
              inputmode="numeric"
              pattern="[0-9]*"
              v-model="visita.css"
            ></v-text-field>
          </v-col>
          <v-col md="6" cols="12">
            <v-text-field
              label="NUL(Nitrogênio uréico do leite)"
              class="font-weight-medium title"
              clearable
              :dense="isMobile()"
              outlined
              inputmode="numeric"
              pattern="[0-9]*"
              v-model="visita.nul"
              suffix="mg/dL"
            ></v-text-field>
          </v-col>
          <v-col cols="12" class="mt-2">
            <btn-salvar-dados-visita />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import BtnSalvarDadosVisita from "./BtnSalvarDadosVisita.vue";
import ToolbarCardVisita from "./ToolbarCardVisita.vue";
export default {
  components: { ToolbarCardVisita, BtnSalvarDadosVisita },
  computed: mapState("visitaTecnica", ["configuracoes", "visita"]),
  watch: {
    dialog: function (open) {
      if (!open) {
        this.$router.go(-1);
      }
    },
  },
  data: () => ({
    dialog: false,
  }),
  methods: {
    isMobile() {
      return this.$mq == "sm";
    },
  },
  mounted() {
    this.dialog = true;
  },
};
</script>

<style>
</style>